module.exports = __webpack_public_path__ + "img/n6.37de18a2.png";